// @flow
import Button from 'antd/lib/button/button';
import Datepicker from 'antd/lib/date-picker';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

import { OrgUnitMultiSelect } from '../../../../components';
import Field from '../../../../components/card/Field';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import VehicleSelect from '../../../../components/selects/VehicleSelect';
import Spoiler from '../../../../components/ui/Spoiler';
import { formatDateTimeToISOString } from '../../../../lib/helpers';
import type { VehicleUtilizationFilter } from '../../../../lib/types/vehicleUtilization';

const SpoilerContent = styled.div`
  padding: 16px;
`;
const Footer = styled(GridItem)`
  & > * {
    margin-right: 16px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const { RangePicker } = Datepicker;

type Props = {
  onChangeFilter: (key: $Keys<VehicleUtilizationFilter>, value: any) => void,
  params: VehicleUtilizationFilter,
  cleanParams: () => void,
  applyParams: () => Promise<any>,
  onExport: Function
};

/**
 * Фильтр с параметрами для отчета фактической занятости ТС
 */
export default class Filter extends React.Component<Props> {
  render() {
    const { params, onExport } = this.props;
    return (
      <Spoiler defaultExpanded label="Параметры">
        <SpoilerContent>
          <Grid gutter="16px" media={[{ size: 'lg', cols: 6 }]}>
            <GridItem>
              <Field label="Отчетный период">
                <RangePicker
                  format="DD.MM.YYYY HH:mm"
                  showTime={{
                    format: 'HH:mm',
                    defaultValue: [
                      moment('00:00', 'HH:mm'),
                      moment('23:59', 'HH:mm')
                    ]
                  }}
                  placeholder={['Начало', 'Конец']}
                  value={[
                    params.startDate ? moment.utc(params.startDate) : null,
                    params.endDate ? moment.utc(params.endDate) : null
                  ]}
                  onChange={(value, dateString) => {
                    const [startDate, endDate] = value;
                    const [startDateString, endDateString] = dateString;
                    this.props.onChangeFilter(
                      'startDate',
                      formatDateTimeToISOString(startDate, startDateString)
                    );
                    this.props.onChangeFilter(
                      'endDate',
                      formatDateTimeToISOString(endDate, endDateString)
                    );
                  }}
                />
              </Field>
            </GridItem>

            <GridItem>
              <Field label="Филиал">
                <OrgUnitMultiSelect
                  value={params.orgUnitIds}
                  onChange={values =>
                    this.props.onChangeFilter('orgUnitIds', values)
                  }
                  allowClear
                  placeholder="Все филиалы"
                />
              </Field>
            </GridItem>

            <GridItem>
              <Field label="Транспортные средства">
                <VehicleSelect
                  mode="multiple"
                  value={params.inventoryNumbers}
                  onChange={(values: string[]) =>
                    this.props.onChangeFilter('inventoryNumbers', values)
                  }
                  placeholder="Все ТС"
                  allowClear
                />
              </Field>
            </GridItem>

            <Footer fullWidth>
              <Button type="primary" onClick={onExport}>
                Экспорт
              </Button>
              <Button type="primary" onClick={this.props.applyParams}>
                Применить
              </Button>
              <Button type="secondary" onClick={this.props.cleanParams}>
                Очистить
              </Button>
            </Footer>
          </Grid>
        </SpoilerContent>
      </Spoiler>
    );
  }
}
